module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Common 通用")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("1. Margin相关")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"no-margin\"></div>\n<div class=\"margin5\"></div>\n<div class=\"margin10\"></div>\n<div class=\"margin20 no-margin-left\"></div>\n<div class=\"margin20 no-margin-bottom\"></div>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("2. Padding相关")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"no-padding\"></div>\n<div class=\"padding5\"></div>\n<div class=\"padding10\"></div>\n<div class=\"padding20 no-padding-left\"></div>\n<div class=\"padding20 no-padding-bottom\"></div>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("3. Float 相关")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--clearfix清除父元素浮动-->\n<article class=\"clearfix\">\n<!--pull-left向左浮动-->\n  <section class=\"pull-left\">.pull-left</section>\n  <!--pull-right 向右浮动-->\n  <section class=\"pull-right\">.pull-right</section>\n</article>")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("4. List 列表(清除padding-left和list-style)")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<ul class=\"unstyled-list\">\n  <li>Item1</li>\n  <li>Item2</li>\n  <li>Item3</li>\n  <li>Item4</li>\n  <li>Item5</li>\n</ul>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("5. Shadow 阴影")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div class=\"shadow\">shadow</div>\n<div class=\"block-shadow\">block-shadow</div>\n<div class=\"bottom-shadow\">bottom-shadow</div>\n<div class=\"text-shadow\">text-shadow</div>\n")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan no-margin"
  }, [_vm._v("\n        .no-margin\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin5"
  }, [_vm._v("\n        .margin5\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin10"
  }, [_vm._v("\n        .margin10\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin15"
  }, [_vm._v("\n        .margin15\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20"
  }, [_vm._v("\n        .margin20\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-top"
  }, [_vm._v("\n        .no-margin-top\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-right"
  }, [_vm._v("\n        .no-margin-right\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-bottom"
  }, [_vm._v("\n        .no-margin-bottom\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan margin20 no-margin-left"
  }, [_vm._v("\n        .no-margin-left\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding0"
  }, [_vm._v("\n        .padding0\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding5"
  }, [_vm._v("\n        .padding5\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding10"
  }, [_vm._v("\n        .padding10\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding15"
  }, [_vm._v("\n        .padding15\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20"
  }, [_vm._v("\n        .padding20\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-top"
  }, [_vm._v("\n        .no-padding-top\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-right"
  }, [_vm._v("\n        .no-padding-right\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-bottom"
  }, [_vm._v("\n        .no-padding-bottom\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box"
  }, [_c('div', {
    staticClass: "fg-white bg-cyan padding20 no-padding-left"
  }, [_vm._v("\n        .no-padding-left\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "clearfix",
    staticStyle: {
      "padding": "10px",
      "border": "1px solid #eee"
    }
  }, [_c('section', {
    staticClass: "pull-left padding15 bg-amber fg-white"
  }, [_vm._v("\n        .pull-left\n      ")]), _vm._v(" "), _c('section', {
    staticClass: "pull-right padding15 bg-amber fg-white"
  }, [_vm._v("\n        .pull-right\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "unstyled-list"
  }, [_c('li', [_vm._v("Item1")]), _vm._v(" "), _c('li', [_vm._v("Item2")]), _vm._v(" "), _c('li', [_vm._v("Item3")]), _vm._v(" "), _c('li', [_vm._v("Item4")]), _vm._v(" "), _c('li', [_vm._v("Item5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 shadow "
  }, [_vm._v("\n        .shadow\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 block-shadow"
  }, [_vm._v("\n        .block-shadow\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 bottom-shadow"
  }, [_vm._v("\n        .bottom-shadow\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "demo-box"
  }, [_c('div', {
    staticClass: "margin10 padding20 text-shadow"
  }, [_vm._v("\n        .text-shadow\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71785220"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helper/helper.vue
// module id = 403
// module chunks = 1